import Modal from 'components/Modal/Modal'
import React from 'react'
interface ModalBuySomethingProps {
  body: board.Board | undefined
  onClose: () => void
}
const ModalBuySomething: React.FC<ModalBuySomethingProps> = ({ onClose, body }) => {
  return (
    <Modal
      onClose={onClose}
      title='Dodano profil'
      icon='tabliczka'
      secondaryButton='Rozumiem'
      secondaryButtonAction={onClose}
      noTopPadding
    >
      <div className="modal__buySomething">
        <div className="subtitle">
          <span>{body?.name}</span>
        </div>
        {!body?.gps && <div className="location">
          Pamiętaj, aby dodać lokalizację pomnika
        </div>}
        <p className="empty">
          Utworzyłeś darmowy profil, w każdej chwili możesz dokupić tabliczkę z kodem QR, aby bliscy mogli ją zeskanować.
        </p>
      </div>
    </Modal>
  )
}

export default ModalBuySomething